// src/api/siloamStatusApi.js
import { statusEmployeeData } from "./mock/statusEmployeeData"

/**
 * Mendapatkan daftar status kepegawaian Siloam
 * @returns {Promise<Array>}
 */
export const getStatusEmployee = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(statusEmployeeData);
    }, 400);
  });
};